/**
 * Soft path builders for Resource Fabric / field-robot concepts that may exist
 * on staging before the local SPA contract regenerates.
 * Paths are browser-relative (no /api prefix) for shell `api()`.
 */

export const SRF_CONCEPTS_TIMEOUT_MS = 20000;

function qs(query = {}) {
  const params = new URLSearchParams();
  for (const [k, v] of Object.entries(query || {})) {
    if (v == null || v === "") continue;
    params.set(k, String(v));
  }
  const s = params.toString();
  return s ? `?${s}` : "";
}

export function buildGetPhysicalInhibitStatusPath(query = {}) {
  return `/sa/resource-fabric/physical-inhibits/status${qs(query)}`;
}

export function buildPostPhysicalInhibitPath() {
  return "/sa/resource-fabric/physical-inhibits";
}

export function buildPostPhysicalInhibitClearPath(inhibitId) {
  return `/sa/resource-fabric/physical-inhibits/${encodeURIComponent(String(inhibitId || ""))}/clear`;
}

export function buildGetAdapterCertificationsPath(query = {}) {
  return `/sa/resource-fabric/adapter-certifications${qs(query)}`;
}

export function buildPostAdapterCertificationPath() {
  return "/sa/resource-fabric/adapter-certifications";
}

export function buildPostAdapterCertificationDecisionPath(certificationId) {
  return `/sa/resource-fabric/adapter-certifications/${encodeURIComponent(String(certificationId || ""))}/decisions`;
}

export function buildPostAdapterCertificationRevokePath(certificationId) {
  return `/sa/resource-fabric/adapter-certifications/${encodeURIComponent(String(certificationId || ""))}/revoke`;
}

export function buildGetExternalRobotsCatalogPath(query = {}) {
  return `/external-robots/catalog${qs(query)}`;
}

export function buildGetExternalRobotsIntegrationsPath() {
  return "/external-robots/integrations";
}

export function buildPostExternalRobotsIntegrationsPath() {
  return "/external-robots/integrations";
}

export function buildGetExternalRobotsUnitsPath() {
  return "/external-robots/units";
}

export function buildPostExternalRobotsUnitsPath() {
  return "/external-robots/units";
}

export function softAdapterKindLabel(raw) {
  const s = String(raw || "").trim();
  if (!s) return "Equipment";
  if (/unitree/i.test(s)) return "Field robot · walk";
  if (/dji/i.test(s)) return "Field robot · air";
  if (/siren/i.test(s)) return "Siren";
  if (/camera/i.test(s)) return "Camera";
  if (/human|responder/i.test(s)) return "Responder";
  if (/motion[\s_-]*execute/i.test(s)) return "Move command";
  if (/task[\s_-]*dispatch/i.test(s)) return "Mission send";
  if (/execute/i.test(s) && /motion/i.test(s)) return "Move command";
  if (/dispatch/i.test(s) && /task/i.test(s)) return "Mission send";
  if (/^actuator/i.test(s)) return "Equipment";
  return s.replace(/[_./]+/g, " ").replace(/\s+/g, " ").trim()
    .replace(/\bexecute\b/gi, "run")
    .replace(/\bdispatch\b/gi, "send");
}

export function softCertStateLabel(raw) {
  const s = String(raw || "").trim().toLowerCase();
  if (s === "active" || s === "approved") return "Approved";
  if (s === "pending") return "Pending review";
  if (s === "rejected") return "Declined";
  if (s === "revoked") return "Revoked";
  if (s === "expired") return "Expired";
  return s ? s.replace(/_/g, " ") : "—";
}

export function softRobotVendorLabel(raw) {
  const s = String(raw || "").trim().toLowerCase();
  if (s === "dji") return "Air unit";
  if (s === "unitree") return "Ground unit";
  return s ? s.replace(/_/g, " ") : "Field unit";
}
